<template>
  <BaseLayout>
    <VContainer fluid class="error-background" data-testid="page-error">
      <Component :is="errorPage" :error="error" />
    </VContainer>
  </BaseLayout>
</template>

<script lang="ts" setup>
import type { NuxtError } from '#app'
import error4xx from '~/components/error/4xx.vue'
import error500 from '~/components/error/500.vue'
import BaseLayout from "~/components/layout/BaseLayout.vue";


const props = defineProps<{
  error: NuxtError
}>()


const { $appInsights } = useNuxtApp()

const errorPage = computed(() => {
  try {
    if (!props.error) {
      return error500
    }
    const statusCode = props.error.statusCode ?? 500
    if (isNaN(statusCode)) {
      return error500
    }
    if (statusCode !== 404) {
      // $appInsights is undefined on SSR without a connection string (local, e2e).
      $appInsights?.trackException({
        exception: new Error(`${statusCode}: ${JSON.stringify(props.error)}`)
      })
    }
    return statusCode >= 400 && statusCode < 500 ? error4xx : error500
  } catch (e) {
    $appInsights?.trackException({
      exception: new Error(`Error in error page: ${e}`)
    })
    return error500
  }
})
</script>

<style lang="scss" scoped>
  .error-background {
    background-color: rgb(var(--v-theme-backgroundPage));
    min-height: 25vh;
  }
</style>
